import { signInWithGoogle } from "services/auth";
import { Button, IconButton } from "ui";

export default function GoogleButton({ minified, ...props }) {
  const Component = !minified ? Button : IconButton;

  return (
    <Component provider="google" {...props} onClick={signInWithGoogle}>
      <img src="/assets/google.svg" alt="Google" />
      {!minified && "Continuar con Google"}
    </Component>
  );
}
